<template>
  <div class="page-header" :style="color ? '--color:' + color : ''">
    <div class="container">
      <div class="content-wrapper">
        <h1 v-text="title"></h1>
        <p v-if="description" v-text="description"></p>
        <slot></slot>
      </div>
      <img
        :src="image || '/images/helpers/meeee.png'"
        :alt="title"
        class="mee"
      />
    </div>
    <img
      :src="
        background ||
        'https://img.freepik.com/premium-photo/blurred-bookshelf-many-old-books-book-shop-library_36051-168.jpg?w=1380'
      "
      :alt="app_name()"
      class="bg"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    description: {
      required: false,
      type: String,
      default: null,
    },
    image: {
      required: false,
      type: String,
      default: null,
    },
    background: {
      required: false,
      type: String,
      default: null,
    },
    color: {
      required: false,
      type: String,
      default: null,
    },
  },
};
</script>
<style lang="scss" scoped>
.page-header {
  --color: #6d4e3a;
  height: 340px;
  position: relative;
  background: var(--color);
  overflow: hidden;
  margin-bottom: 1.4rem;
  &:after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, var(--color) 20%, rgba(0, 0, 0, 0) 125%);
    z-index: 2;
  }
  .container {
    position: relative;
    height: 100%;
    .content-wrapper {
      position: relative;
      z-index: 5;
      display: flex;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      max-width: 70%;

      h1 {
        color: #fff;
        font-size: 3rem;
        font-weight: 700;
        margin: 0;
      }
      p {
        color: #fff;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.2;
        opacity: 0.9;
        margin: 0;
        margin-left: 5px;
        margin-top: 0.6rem;
      }
      .search-bar {
        margin-top: 1.5rem;
        margin-bottom: 0;
      }
    }
    .mee {
      position: absolute;
      z-index: 3;
      bottom: 0;
      right: 0;
      width: auto;
      height: 100%;
      object-fit: contain;
      object-position: center;
      padding-top: 5px;
      opacity: 0.9;
      @media (max-width: 768px) {
        max-height: 80%;
      }
    }
  }
  .bg {
    position: absolute;
    top: 0;
    right: 0;
    width: 80%;
    height: 100%;
    background: #000;
    z-index: 1;
    filter: blur(2px);
    object-fit: cover;
  }

  @media (max-width: 576px) {
    background: transparent;
    color: var(--dark);
    height: unset;
    padding-top: 20px;
    padding-bottom: 0;
    .container .content-wrapper {
      max-width: 100%;
      text-align: center;
      h1 {
        font-size: 1.8rem;
        color: var(--dark);
        line-height: 1.2;
      }
      p {
        font-size: 0.9rem;
        margin: auto;
        color: var(--dark);
        opacity: 0.6;
        margin-top: 0.3rem;
      }
    }
    .container .mee {
      display: none;
    }
    &:after {
      content: none;
    }
    .bg {
      display: none;
    }
  }
}
</style>